import Get from '../services/Get';
import Post from '../services/Post';
import Put from '../services/Put';
import Delete from '../services/Delete';

import { nexcareVersion } from '../config/serviceConfig';

// Menu Parameter
const getListParameter = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}`, token);
const getListParameterDetail = (id, token) => Get(`/${nexcareVersion}/nexcare/parameter/${id}`, token);

const getListParameterPriority = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name like target_resolution_time_priority`, token);
const getListParameterChannel = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name like targetresponsetime`, token);
const getListParameterTicketWaiting = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq grabticket`, token);
const getListParameterTolerance = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq toleranceassigncs`, token);
const getListParameterForgeLogout = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq ForceLogOutDesktop`, token);
const getListParameterMaxReassignPhoneEmail = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq maxreassignphoneemail`, token);
const getListParameterMaxReassignLiveChat = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq maxreassignlivechat`, token);
const getListParameterMaxQueueReassign = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq maxqueuereassign`, token);
const getListParameterWorkstart = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq workstart`, token);
const getListParameterWorkend = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq workend`, token);
const getListParameterBreaktime = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq breaktime`, token);
const getListParameterCutOffCommission = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq cutoffkomisi`, token);
const getListParameterMaxUserOffline = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq maxuseroffline`, token);
const getListParameterIntervalGrabTicket = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq intervalgrabticket`, token);
const getListParameterIntervalGrabTicketTimeout = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/parameter?page=${page}&limit=${limit}&filter=name eq grab_ticket_timeout`, token);

const putDataParameter = (data, id, token) => Put(`/${nexcareVersion}/nexcare/parameter/${id}`, data, token);

const getListShift = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/list-shift?page=${page}&limit=${limit}`, token);

// Menu CS Agent
const getListUserCustomerServiceWorkShift = (page, limit, csActive = false, token) => Get(`/${nexcareVersion}/nexcare/work-shift/user-cs?page=${page}&limit=${limit}&csActive=${csActive}&order=alias_name asc`, token);
const getListShiftWorkShift = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/work-shift/list-shift?page=${page}&limit=${limit}`, token);
const getInitiatetWorkShift = (token) => Get(`/${nexcareVersion}/nexcare/work-shift/initiate`, token);
const getListWorkShift = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/work-shift?page=${page}&limit=${limit}&order=id desc`, token);
const postDataWorkShift = (data, token) => Post(`/${nexcareVersion}/nexcare/work-shift`, data, token);
const deleteWorkShift = (data, id, token) => Delete(`/${nexcareVersion}/nexcare/work-shift/${id}`, data, token);

// Menu Job Process
const getInitiateJobProcess = (filter, token) => Get(`/${nexcareVersion}/nexcare/job-process/initiate?filter=${filter}`, token);
const getJobProcess = (page, limit, order, filter, token) => Get(`/${nexcareVersion}/nexcare/job-process?page=${page}&limit=${limit}&order=${order}&filter=${filter}`, token);
const getJobProcessDetail = (id, token) => Get(`/${nexcareVersion}/nexcare/job-process/${id}`, token);
const getJobProcessDownload = (id, token) => Get(`/${nexcareVersion}/nexcare/job-process/${id}/download`, token);

// Menu Login History
const getListUserCustomerServiceLoginHistory = (page, limit, isAll = false, token) => Get(`/${nexcareVersion}/nexcare/history-login/user-cs?page=${page}&limit=${limit}&is_all=${isAll}&order=alias_name asc`, token);
const getInitiateHistoryLogin = (userType, token) => Get(`/${nexcareVersion}/nexcare/history-login/initiate?userType=${userType}`, token);
const getHistoryLogin = (page, limit, order, userType, token) => Get(`/${nexcareVersion}/nexcare/history-login?page=${page}&limit=${limit}&order=${order}&userType=${userType}`, token);
const exportHistoryLogin = (userIds, startDate, endDate, dateFormat, token) => Get(`/${nexcareVersion}/nexcare/history-login/export?user_id=${userIds}&start_date=${startDate}&end_date=${endDate}&date_format=${dateFormat}`, token);

const getInitiateSearchHistoryLogin = (userType, filter, token) => Get(`/${nexcareVersion}/nexcare/history-login/initiate?userType=${userType}${filter}`, token);
const getSearchHistoryLogin = (page, limit, order, userType, filter, token) => Get(`/${nexcareVersion}/nexcare/history-login?page=${page}&limit=${limit}&order=${order}&userType=${userType}${filter}`, token);

// Menu Queue
const getListUserCustomerServiceQueue = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/queue/user-cs?page=${page}&limit=${limit}`, token);
const getSearchUserCustomerServiceQueue = (page, limit, filter, token) => Get(`/${nexcareVersion}/nexcare/queue/user-cs?page=${page}&limit=${limit}&filter=alias_name like ${filter}`, token);
const getInitiateQueueAssigned = (token) => Get(`/${nexcareVersion}/nexcare/user-cs/queue/initiate`, token);
const getQueueAssigned = (page, limit, order, filter, token) => Get(`/${nexcareVersion}/nexcare/user-cs/queue?page=${page}&limit=${limit}&order=${order}${filter}`, token);

const getInitiateQueueEscalated = (token) => Get(`/${nexcareVersion}/nexcare/user-cs/queue/initiate`, token);
const getQueueEscalated = (page, limit, order, filter, token) => Get(`/${nexcareVersion}/nexcare/user-cs/queue?page=${page}&limit=${limit}&order=${order}${filter}&is_escalated=true`, token);

// Menu Session
const getListCustomerService = (isOnline, token) => Get(`/${nexcareVersion}/nexcare/user-cs/online?order=alias_name&onlineCSOnly=${isOnline}`, token);
const putDataEndSession = (data, id, token) => Put(`/${nexcareVersion}/nexcare/user-cs/end-session/${id}`, data, token);

// Menu Chat Bot Flow
const getListChatBotQuestion = (page, limit, filter = '', token) => Get(`/${nexcareVersion}/nexcare/flowchatbot/question?page=${page}&limit=${limit}&filter=${filter}`, token);
const initiateGetListChatBotQuestion = (filter = '', token) => Get(`/${nexcareVersion}/nexcare/flowchatbot/question/initiate?filter=${filter}`, token);
const getDetailChatBotByType = (type, token) => Get(`/${nexcareVersion}/nexcare/flowchatbot/detail?type=${type}`, token);
const getDetailChatBotQNAById = (id, token) => Get(`/${nexcareVersion}/nexcare/flowchatbot/question/${id}`, token);
const getChatBotAnswers = (page, limit, type, key, keyword = '', token) => Get(`/${nexcareVersion}/nexcare/flowchatbot/answer?page=${page}&limit=${limit}&typeMessage=${type}&key=${key}&keyword=${keyword}`, token)
const getChatBotKMS = (page = 1, limit = 100, keyword = '', token) => Get(`/${nexcareVersion}/nexcare/flowchatbot/kms?page=${page}&limit=${limit}&keyword=${keyword}`, token)
const checkChatBotFirstMessage = (token) => Get(`/${nexcareVersion}/nexcare/flowchatbot/check-first-question`, token)
const postChatBotGreeting = (data, token) => Post(`/${nexcareVersion}/nexcare/flowchatbot/greeting`, data, token);
const postChatBotSolution = (data, token) => Post(`/${nexcareVersion}/nexcare/flowchatbot/solution`, data, token);
const postChatBotClosing = (data, token) => Post(`/${nexcareVersion}/nexcare/flowchatbot/closing`, data, token);
const postChatBotError = (data, token) => Post(`/${nexcareVersion}/nexcare/flowchatbot/error`, data, token);
const postChatBotCreateTicket = (data, token) => Post(`/${nexcareVersion}/nexcare/flowchatbot/created-ticket`, data, token);
const postChatBotTimeout = (data, token) => Post(`/${nexcareVersion}/nexcare/flowchatbot/timeout`, data, token);
const postChatBotQNA = (data, token) => Post(`/${nexcareVersion}/nexcare/flowchatbot/question`, data, token);
const putChatBotQNA = (data, token) => Put(`/${nexcareVersion}/nexcare/flowchatbot/question`, data, token);
const deleteChatBotQNA = (id, data, token) => Delete(`/${nexcareVersion}/nexcare/flowchatbot/question/${id}`, data, token);

const API_SETTINGS = {
    getListParameter,
    getListParameterDetail,
    getListParameterPriority,
    getListParameterChannel,
    getListParameterTicketWaiting,
    getListParameterTolerance,
    getListParameterForgeLogout,
    getListParameterMaxReassignPhoneEmail,
    getListParameterMaxReassignLiveChat,
    getListParameterMaxQueueReassign,
    putDataParameter,
    getListShift,
    postDataWorkShift,
    getListUserCustomerServiceWorkShift,
    getListShiftWorkShift,
    getInitiatetWorkShift,
    getListWorkShift,
    deleteWorkShift,
    getInitiateJobProcess,
    getJobProcess,
    getJobProcessDetail,
    getJobProcessDownload,
    getListUserCustomerServiceLoginHistory,
    getInitiateHistoryLogin,
    getHistoryLogin,
    exportHistoryLogin,
    getListUserCustomerServiceQueue,
    getSearchUserCustomerServiceQueue,
    getInitiateQueueAssigned,
    getInitiateSearchHistoryLogin,
    getSearchHistoryLogin,
    getQueueAssigned,
    getInitiateQueueEscalated,
    getQueueEscalated,
    getListCustomerService,
    putDataEndSession,
    getListParameterWorkstart,
    getListParameterWorkend,
    getListParameterBreaktime,
    getListParameterCutOffCommission,
    getListParameterMaxUserOffline,
    getListParameterIntervalGrabTicket,
    getListParameterIntervalGrabTicketTimeout,
    getListChatBotQuestion,
    initiateGetListChatBotQuestion,
    getDetailChatBotByType,
    getDetailChatBotQNAById,
    getChatBotAnswers,
    getChatBotKMS,
    checkChatBotFirstMessage,
    postChatBotGreeting,
    postChatBotSolution,
    postChatBotError,
    postChatBotClosing,
    postChatBotCreateTicket,
    postChatBotTimeout,
    postChatBotQNA,
    putChatBotQNA,
    deleteChatBotQNA
}

export default API_SETTINGS;